<div [routerLink]="['/profile', item?.id]" class="user-item">
  <img class="user-item__image" src="assets/img/user_placeholder.svg" />
  <div class="user-item__description">
    <div class="user-item__name">
      <div class="user-item__label">
        {{ 'Person' | translate }}
      </div>
      <div class="user-item__value">{{ item.nickname }}</div>
    </div>
  </div>
</div>
